<template>
    <!--Wrapper - Outer-->
    <div class="wrapper outer">
        <div class="wrapper inner">
            <!--Page-->
            <div class="page">
                <!--Content-->
                <div class="content">
                    <!--Login Page-->
                    <div class="login-page">
                        <div class="page-wrapper primary">
                            <!--Page Body - Primary-->
                            <section class="section page-body primary">
                                <!--Wizard-->
                                <div class="wizard">
                                    <!--Login Form - Primary-->
                                    <section class="section login-form primary">
                                        <div class="section-wrapper primary">
                                            <!--Header Section-->
                                            <div class="login-form-header">
                                                <div class="header-logo">
                                                    <div class="logo">
                                                        <img src="/assets/images/logo/logo-escolarai-a.svg" />
                                                    </div>
                                                </div>
                                                <div class="header-background">
                                                    <div class="background">
                                                        <img src="/assets/images/root/login-form-primary-header-background-1.png" />
                                                    </div>
                                                </div>
                                            </div>

                                            <!--Content Section-->
                                            <div class="login-form-content">
                                                <div class="content-wrapper primary">
                                                    <div class="content-text">
                                                        <div class="title">
                                                            <h2>
                                                               Esqueceu sua senha?
                                                            </h2>
                                                            <p>
                                                                Digite seu e-mail abaixo para receber as instruções de recuperação de senha.
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="content-form">
                                                        <div class="form-group">
                                                            <div class="form-label">
                                                                <label>
                                                                    Email
                                                                </label>
                                                            </div>
                                                            <div class="form-input">
                                                                <input type="email" class="form-control" v-model="email" placeholder="Digite seu e-mail"/>
                                                            </div>
                                                        </div>
                                                        <div class="form-button">
                                                            <div class="button">
                                                                <button type="button" class="btn btn-block btn-form" @click="handleRecuperarSenha">
                                                                   Recuperar Senha
                                                                </button>
                                                                <p class="text-center hasAccount">
                                                                    Lembrou sua senha? <a href="/">Faça login</a>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>   
                                        </div>
                                    </section>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import login from '@/utils/login';

export default {
    name: 'EsqueciSenha',
    components: {},
    data() {
        return {
            email: ''
        };
    },
    computed: {
        ...mapState(['user'])
    },
    methods: {
        async handleRecuperarSenha() {
            try {
                const payload = {
                    email: this.email
                };
                await login.recuperarSenha(payload);
                // Mostrar mensagem de sucesso
                alert('Um e-mail com instruções foi enviado para você');
                this.$router.push('/');
            } catch (error) {
                console.error('Erro ao recuperar senha:', error);
                alert('Erro ao recuperar senha. Tente novamente.');
            }
        }
    }
};
</script>
<style scoped lang="scss">
.title p {
    color: white;
}
.wizard .login-form.primary .login-form-content .content-wrapper.primary .content-form .form-button .button .btn-form {
    display: block;
    width: 100% !important;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    text-transform: uppercase;
    padding: .65rem 1rem;
    color: #ffffff;
    background-color: #34a5e4;
}
.hasAccount { 
    color: white;
    margin: 10px;

    a {
        color: white;
    }
}
</style>